export const API_BASE = process.env.REACT_APP_API_BASE ?? '';

// Guards against a JSON response body that isn't actually an array - `?? []`
// alone only catches null/undefined, so a 200 response whose body is
// unexpectedly an object (e.g. an API error shape slipping through with a
// success status, or any other backend hiccup) still reaches a bare `.map()`
// and crashes with "X.map is not a function", which - with no error boundary
// catching it below the app root - blanks the entire page. Use this any time
// a fetched value is about to be `.map()`/`.filter()`'d as a list.
export function asArray<T>(value: unknown): T[] {
    return Array.isArray(value) ? (value as T[]) : [];
}
